import React from 'react';
import { CompassIcon } from 'lucide-react';
import { channel } from '../data/channel';
const links = [{
  href: `${channel.url}/videos`,
  label: 'Відео'
}, {
  href: `${channel.url}/playlists`,
  label: 'Плейлисти'
}, {
  href: `${channel.url}/shorts`,
  label: 'Shorts'
}, {
  href: `${channel.url}/about`,
  label: 'Про канал'
}];
export function SiteFooter() {
  return <footer className="bg-ink py-14" data-id="element-121" data-mp="3dguvx64qv0bh">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 md:flex-row md:items-center md:justify-between md:px-8" data-id="element-122" data-mp="3dhw4n3yafaq1">
        <div className="flex items-center gap-2.5" data-id="element-123" data-mp="38g6vxuyjf954">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ember text-ember-ink" data-id="element-124" data-mp="33i59r15tetpf">
            <CompassIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="2ykdjebktjfnc" />
          </span>
          <div data-id="element-126" data-mp="11r1x66cd7528">
            <p className="font-display text-base font-semibold" data-id="element-127" data-mp="11rk35uotwxnc">{channel.name}</p>
            <p className="text-sm text-muted" data-id="element-128" data-mp="wsgyibcrgtfw">{channel.handle} на YouTube</p>
          </div>
        </div>
        <nav aria-label="Канал на YouTube" data-id="element-129" data-mp="15qc2chkyblhj">
          <ul className="flex flex-wrap gap-x-7 gap-y-2" data-id="element-130" data-mp="15pagdi2edel1">
            {links.map(link => <li key={link.label} data-id="element-131" data-mp="1arj8kc7g4cm3">
                <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-paper/80 transition-colors duration-150 hover:text-paper" data-id="element-132" data-mp="vsp8moyztpdi">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <div className="flex flex-col gap-1 md:items-end" data-id="element-133" data-mp="1tfo6h31f93cz">
          <a href={`mailto:${channel.email}`} className="text-sm font-semibold text-paper transition-colors duration-150 hover:text-ember" data-id="element-134" data-mp="1esbh138hudhb">
            {channel.email}
          </a>
          <p className="text-sm text-muted" data-id="element-135" data-mp="27ffjp1k46fpx">© {new Date().getFullYear()} {channel.name}</p>
        </div>
      </div>
    </footer>;
}